declare global {
  interface Window {
    fbq?: any;
  }
}

const fbq = (...args: any[]) => {
  if (typeof window === 'undefined') return;
  try {
    (window as any).fbq?.(...args);
  } catch {}
};

export const fbInit = (pixelId?: string) => {
  if (!pixelId) return;

  fbq('init', pixelId);
  fbq('track', 'PageView');
};

export const fbTrack = (eventName: string, params?: Record<string, any>) => {
  fbq('track', eventName, params);
};
